import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { UtilService } from 'src/app/shared/services/util.service';
import { UsersService } from 'src/app/users/users.service';
import {
    AiGeneralSummaryModalModule
} from '../../../shared/modals/ai-general-summary-modal/ai-general-summary-modal.module';
import { CalibrationService } from '../../calibration.service';
import { CalibrationUserOverallEvaluation } from './overall-evaluation/overall-evaluation.component';
import { QualitativeEvaluationModule } from './qualitative-evaluation/qualitative-evaluation.module';
import { CalibrationUserOverviewModal } from './user-overview.modal';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        PipesModule,
        MatTooltipModule,
        AiGeneralSummaryModalModule,
        QualitativeEvaluationModule
    ],
    declarations: [
        CalibrationUserOverviewModal,
        CalibrationUserOverallEvaluation,
    ],
    exports: [
        CalibrationUserOverviewModal,
        CalibrationUserOverallEvaluation,
    ],
    providers: [
        UsersService,
        CalibrationService,
        UtilService
    ]
})
export class UserCalibrationOverviewModule {
}
